/** @file mirrorGuard: refuses (with a warning toast) to key a frame in a mirrorHalf clip's computed half. */
import type { Clip } from '@zilo/pose3d-format/types/clip';
import type { EditorActions } from '../../state/editorTypes';
import { mirrorStart } from './mirrorStart';

/** The clip fields the guard reads. */
type GuardClip = Pick<Clip, 'name' | 'mirrorHalf' | 'frames' | 'loopStart'>;

/** True (and `notify('warning', ...)`) when `frame` lies in the mirrored half of `clip`; the caller dispatches nothing. */
export function mirrorGuard(clip: GuardClip, frame: number, notify: EditorActions['notify']): boolean {
  const start = mirrorStart(clip);
  if (start === null || frame < start) return false;
  const half = start - clip.loopStart;
  notify('warning', `Frame ${frame} of "${clip.name}" is in the mirrored half (${start}..${clip.frames}); key frame ${frame - half} instead`);
  return true;
}
